import React, { useState } from 'react'
import { Card, CardContent, Grid, IconButton } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import Table from '@material-ui/core/Table'
import SummarySirna from './SummarySirna'
import { FormattedMessage } from 'react-intl'
import messages from '@semi-configurator-messages'
import { ProductDetails, configContext } from '../Sirna'
import {
  ActiveLinkType,
  DeleteType,
  SemiConfigProperties,
  SiRNAProperties,
} from '../enum'
import DeleteAllDialog from '@src/routes/SemiConfigurators/components/DeleteDialog'
import { sirnaRoute, useRouter } from '@src/routes'
import TableContainer from '@material-ui/core/TableContainer'
import { priceFormatter } from '../../../../Configurators/utils/PriceFormatter'
import { initialState } from '../Reducer'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { useSemiConfSaveToSessionMutation } from '@src/mutations/SemiconfigSirnaMutation.generated'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(6, 5, 0),
      marginBottom: theme.spacing(4),
      borderRadius: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    subHead: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(3, 0),
    },
    dFlex: {
      display: 'flex',
    },
    paddingFrScrollBar: {
      display: 'flex',
      paddingRight: theme.spacing(4.25),
    },
    cardContent: {
      padding: theme.spacing(0),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    deleteMargin: {
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(5),
    },
    label: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    deleteButton: {
      padding: theme.spacing(0),
    },
    deleteAllText: {
      fontSize: theme.typography.pxToRem(16),
    },
    sequenceInfo: {
      fontSize: theme.typography.pxToRem(16),
      paddingTop: theme.spacing(2.5),
    },
    priceStyle: {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(17),
      paddingTop: theme.spacing(2.5),
    },
    quoteStyle: {
      fontSize: theme.typography.pxToRem(16),
      paddingLeft: theme.spacing(12),
      paddingTop: theme.spacing(5),
    },
    alignRight: {
      textAlign: 'right',
    },
    sequenceProperties: {
      width: '30%',
      '& + td': {
        paddingLeft: theme.spacing(1),
      },
    },
    sequencePropertiesVal: {
      width: '30%',
      paddingLeft: theme.spacing(17),
    },
    tableBodyPadding: {
      paddingLeft: theme.spacing(13),
    },
    tableContainer: {
      maxHeight: 640,
    },
    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },
  }
})

interface ConfirmOrderProps {
  productDetails: ProductDetails
  currencyFormat: string
  thousandSeparator: any
  thousandSpacing: any
  prefixCurrecny: any
  decimalSeparator: any
}

const ConfirmOrderSirna: React.FC<ConfirmOrderProps> = (props) => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(configContext)
  const { siRNAData, selectedData, searchResult } = state
  const [semiConfSaveToSession] = useSemiConfSaveToSessionMutation()
  const [scrollBar, setScrollBar] = useState(false)
  const [delType, setDelType] = useState('')
  const [elementId, setElementId] = useState('')
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [delItem, setDelItem] = useState()
  const router = useRouter()
  const [open, setOpen] = React.useState(false)
  const [message, setMessage] = React.useState<string>('')
  const {
    currencyFormat,
    thousandSeparator,
    thousandSpacing,
    prefixCurrecny,
    decimalSeparator,
  } = props

  const updateError = (value): void => {
    setOpen(true)
    setMessage(value)
  }
  const saveSessionHandler = async (deleteAll = false) => {
    //save the updated value to session
    //for deleteAll, resent to initial state
    return await semiConfSaveToSession({
      variables: {
        input: deleteAll
          ? initialState.searchResult
          : {
              results: searchResult.results,
              term: searchResult.term,
              count: searchResult.count,
              selectedItems: selectedData || [],
            },
        productInput: props.productDetails,
      },
    })
  }
  React.useEffect(() => {
    window.scrollTo(0, 0)
    if (state.selectedData !== undefined) {
      if (state.selectedData.length > 5) {
        setScrollBar(true)
      } else if (state.selectedData.length < 6) {
        setScrollBar(false)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  const deleteOligoItem = (index, type, sirnaID): void => {
    let isDeleteAll = false
    let itemDeleteFlag = false
    const selectedDataArray: any = state.selectedData
    const selectedAddToCartData: any = state.sirnaAddtoCartData.results
    const selectedSubSetList: any[] = []
    selectedData?.forEach((item: any) => {
      selectedSubSetList.push(...item.subSetInfo)
    })
    if (selectedDataArray.length <= 6) {
      setScrollBar(false)
    }
    if (type === DeleteType.Selected && selectedSubSetList.length > 1) {
      siRNAData.forEach((data) => {
        if (data) {
          data.subSetInfo.forEach((subSetData) => {
            if (subSetData.siRNAId === sirnaID) {
              subSetData.checked = false
            }
          })
        }
      })

      if (index !== -1) {
        for (let i = 0; i < selectedDataArray.length; i++) {
          const removedItemIndex = selectedDataArray[i].subSetInfo.findIndex(
            (subSetSingle) => {
              return subSetSingle.siRNAId === sirnaID
            }
          )
          if (
            removedItemIndex !== -1 &&
            selectedDataArray[i].subSetInfo.length > 1
          ) {
            selectedDataArray[i].subSetInfo.splice(removedItemIndex, 1)
            break
          } else if (
            removedItemIndex !== -1 &&
            selectedDataArray[i].subSetInfo.length === 1
          ) {
            selectedDataArray.splice(i, 1)
            break
          }
        }
        selectedAddToCartData.splice(index, 1)
      }
      dispatch({
        type: 'UPDATE_ADD_TO_CART_DATA',
        data: {
          ...state.sirnaAddtoCartData,
          results: selectedAddToCartData,
        },
      })
      dispatch({
        type: 'UPDATE_SELECTED_DATA',
        data: selectedDataArray,
      })

      dispatch({
        type: 'UPDATE_DATA',
        data: [...state.siRNAData],
      })

      if (selectedDataArray.length === 0) {
        itemDeleteFlag = true
      } else {
        saveSessionHandler()
      }
    } else if (
      type === DeleteType.All ||
      (type === DeleteType.Selected && selectedSubSetList.length === 1)
    ) {
      isDeleteAll = true
      dispatch({
        type: 'UPDATE_SELECTED_DATA',
        data: [],
      })
      dispatch({
        type: 'SEARCH_INPUT',
        data: initialState.searchInput,
      })
      dispatch({
        type: 'UPDATE_SEARCH_RESULT',
        data: initialState.searchResult,
      })
      dispatch({ type: 'SET_STEP_NO', data: 0 })
    }

    if (isDeleteAll || itemDeleteFlag) {
      dispatch({
        type: 'SET_INITIAL_STATE',
        data: initialState,
      })
      saveSessionHandler(true)
      const confirmOrder = `${sirnaRoute.index()}?activeLink=${
        ActiveLinkType.selectAssays
      }`
      router.push(confirmOrder)
    }
  }

  const handleDelete = (index, sirnaId): void => {
    setDelDialogOpen(true)
    setDelType(DeleteType.Selected)
    setDelItem(index)
    setElementId(sirnaId)
  }

  // This method is use to render data
  const renderData = () => {
    const result: any[] = []
    const selectedSubSetList: any[] = []
    selectedData?.forEach((item: any) => {
      selectedSubSetList.push(...item.subSetInfo)
    })
    if (selectedSubSetList) {
      selectedSubSetList.forEach((item, index) => {
        let price = ''
        if (
          item.price &&
          item.price !== SemiConfigProperties.Quote &&
          item.price !== '--'
        ) {
          price = priceFormatter(
            parseFloat(item.price),
            currencyFormat,
            thousandSeparator,
            thousandSpacing,
            decimalSeparator,
            prefixCurrecny,
            item?.currencySymbol
          )
        } else if (item.price === SemiConfigProperties.Quote) {
          price = SemiConfigProperties.Quote
        } else {
          price = ActiveLinkType.priceDash
        }

        // To set purification and size values
        let purificationValue = ''
        let sizeValue = ''
        if (item.purification === SiRNAProperties.P1007) {
          purificationValue = SiRNAProperties.Standard
        } else if (item.purification === SiRNAProperties.P1009) {
          purificationValue = SiRNAProperties.HPLC
        }

        if (item.size === SiRNAProperties.S1030) {
          sizeValue = SiRNAProperties.Tennmol
        } else if (item.size === SiRNAProperties.S1033) {
          sizeValue = SiRNAProperties.Twentynmol
        } else if (item.size === SiRNAProperties.S1034) {
          sizeValue = SiRNAProperties.Fiftynmol
        }

        result.push(
          <Card className={classes.cardWrapper} key={index}>
            <CardContent className={classes.cardContent}>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
              >
                <Grid item sm={5}>
                  <div className={classes.sequenceInfo}>
                    <h4>
                      <strong>{item.siRNAId}</strong>
                    </h4>
                  </div>
                </Grid>
                <Grid item sm={4}>
                  <div className={classes.tableBodyPadding}>
                    <Table>
                      <tbody>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage {...messages.GENE_SYMBOL} />:
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{item.geneSymbol}</label>
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage
                                id="SPECIES"
                                defaultMessage="Species"
                              />
                              :
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{item.species}</label>
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage
                                {...messages.SEMI_CONF_REF_SEQ_ID}
                              />
                              :
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{item.refseqId}</label>
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage
                                {...messages.CONF_PURIFICATION_DNA_PLATES}
                              />
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{purificationValue}</label>
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage
                                {...messages.SEMICONF_CONFIRM_ORDER_SIZE_sirna}
                              />
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{sizeValue}</label>
                          </td>
                        </tr>
                        <tr>
                          <td className={classes.sequenceProperties}>
                            <strong>
                              <FormattedMessage
                                {...messages.SEMICONF_CONFIRM_ORDER_SEQ_START_sirna}
                              />
                            </strong>
                          </td>
                          <td className={classes.sequenceProperties}>
                            <label>{item.fuzzyStart}</label>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Grid>
                <Grid item sm={2}>
                  <div
                    className={
                      price === SemiConfigProperties.Quote
                        ? classes.quoteStyle
                        : classes.priceStyle
                    }
                  >
                    {price === SemiConfigProperties.Quote ? (
                      <FormattedMessage {...messages._PC_QUOTE_ITEM} />
                    ) : (
                      `${price}`
                    )}
                  </div>
                </Grid>
                <Grid item sm={1} className={classes.alignRight}>
                  <div>
                    <IconButton
                      aria-label="delete"
                      className={classes.deleteButton}
                      onClick={() => {
                        handleDelete(index, item.siRNAId)
                      }}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )
        return item
      })
    }

    return result
  }

  return (
    <>
      <div>
        <ErrorAlert open={open} setOpen={setOpen} message={message} />
      </div>
      <div className={classes.header}>
        <h3 className={classes.subHead}>
          <strong>
            <FormattedMessage {...messages.SEMICONF_CONFIRM_ORDER_Kicqstart} />
          </strong>
        </h3>
        {selectedData && selectedData?.length > 0 && (
          <div
            className={scrollBar ? classes.paddingFrScrollBar : classes.dFlex}
          >
            <h4>
              <strong className={classes.deleteAllText}>
                <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
              </strong>
            </h4>
            <span className={classes.deleteMargin}>
              <IconButton
                aria-label="delete"
                onClick={() => {
                  setDelDialogOpen(true)
                  setDelType('All')
                  setDelItem(delItem)
                }}
                className={classes.deleteButton}
              >
                <DeleteIcon className={classes.deleteIcon} />
              </IconButton>
            </span>
          </div>
        )}
      </div>
      <div>
        {selectedData && selectedData?.length > 0 ? (
          <TableContainer className={classes.tableContainer}>
            {renderData()}
          </TableContainer>
        ) : (
          <h3 className={classes.subHead}>
            <strong>
              <FormattedMessage {...messages.NO_DATA_FOUND} />
            </strong>
          </h3>
        )}
      </div>
      {selectedData && selectedData?.length > 0 && (
        <SummarySirna
          onDelete={deleteOligoItem}
          productDetails={props.productDetails}
          currencyFormat={props.currencyFormat}
          updateError={updateError}
          thousandSeparator={thousandSeparator}
          thousandSpacing={thousandSpacing}
          prefixCurrecny={prefixCurrecny}
          decimalSeparator={decimalSeparator}
        />
      )}
      <DeleteAllDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteOligoItem}
        elementId={elementId}
      />
    </>
  )
}

export default ConfirmOrderSirna
